"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiCoder = _interopRequireDefault(require("@tencent/spaui-coder"));

var _selected_tip_component = _interopRequireDefault(require("./component/selected_tip_component"));

var _info_component = _interopRequireDefault(require("./component/info_component"));

var _img_component = _interopRequireDefault(require("./component/img_component"));

var _user_item_component = _interopRequireDefault(require("./component/user_item_component"));

var _empty_component = _interopRequireDefault(require("./component/empty_component"));

var _split_component = _interopRequireDefault(require("./component/split_component"));

var _action_component = _interopRequireDefault(require("./component/action_component"));

var _index = require("./utils/index");

var _info = _interopRequireDefault(require("./info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Import =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Import, _PureComponent);

  /**
   * 组件属性说明
   * @alias ImportProps
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {array} data=[]] 数据
   * @property {func} onDataChange 数据回调
   * @property {string} [placeholder=''] 提示
   * @property {bool} [error=false] 是否错误
   * @property {bool} [disabled=false] 是否禁用
   * @property {titleline} 输入框属性
   * @property {string} [value] 选中的数据
   * @property {func} [onChange] 添加数据变更<br />onChange(event, value)
   * @property {titleline} 导入属性
   * @property {string} [importButtonLabel='导入'] 导入按钮文案
   * @property {bool} [importButtonDisabled] 导入按钮是否禁用
   * @property {func} onImport 导入回调<br />onImport = (event, value)
   * @property {titleline} 已选择区域属性
   * @property {string} [selectionTitle='已导入客户'] 已选择区域标题
   * @property {string} [selectionEmptyLabel='请在左侧选择添加客户'] 已选择区域为空提示文案
   * @property {titleline} 自定组件属性
   * @property {func} [SelectedTipComponent] 选中面板标题文案提示组件
   * @property {func} [ImgComponent] UserItemComponent中的img结构
   * @property {func} [InfoComponent] UserItemComponent中的Info信息结构
   * @property {func} [UserItemComponent] 列表元素节点组件
   * @property {func} [EmptyComponent] 没有选中数据提示组件
   * @property {func} [SplitComponent] 分隔符组件
   * @property {func} [ActionComponent] 操作区域组件
   */
  function Import(props) {
    var _this;

    _classCallCheck(this, Import);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Import).call(this, props));
    _this.handleDataChange = _this.handleDataChange.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleImport = _this.handleImport.bind(_assertThisInitialized(_this));
    _this.handleCoderChange = _this.handleCoderChange.bind(_assertThisInitialized(_this));
    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  _createClass(Import, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.value !== 'undefined') {
        this.setState({
          value: nextProps.value
        });
      }
    } // 删掉某个数据回调

  }, {
    key: "handleDataChange",
    value: function handleDataChange(event, itemData) {
      var _this$props = this.props,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data,
          onDataChange = _this$props.onDataChange,
          disabled = _this$props.disabled;
      var result = [];

      if (!disabled && (0, _spauiUtils.isArray)(data)) {
        data.map(function (item) {
          if (!(0, _index.isEqualForObject)(itemData, item)) {
            result.push((0, _spauiUtils.objectAssign)(item));
          }

          return item;
        });

        if ((0, _spauiUtils.isFunction)(onDataChange)) {
          onDataChange(event, result);
        }
      }
    } // 清空回调

  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props2 = this.props,
          onDataChange = _this$props2.onDataChange,
          disabled = _this$props2.disabled;

      if (!disabled) {
        if ((0, _spauiUtils.isFunction)(onDataChange)) {
          onDataChange(event, []);
        }
      }
    } // 导入

  }, {
    key: "handleImport",
    value: function handleImport(event) {
      var onImport = this.props.onImport;
      var value = this.state.value;

      if ((0, _spauiUtils.isFunction)(onImport)) {
        onImport(event, value);
      }
    } // 输入框回调

  }, {
    key: "handleCoderChange",
    value: function handleCoderChange(event, coderValue) {
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;

      if (typeof value === 'undefined') {
        this.setState({
          value: coderValue
        });
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, coderValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          placeholder = _this$props4.placeholder,
          data = _this$props4.data,
          InfoComponent = _this$props4.InfoComponent,
          ImgComponent = _this$props4.ImgComponent,
          UserItemComponent = _this$props4.UserItemComponent,
          importButtonLabel = _this$props4.importButtonLabel,
          _this$props4$selectio = _this$props4.selectionEmptyLabel,
          selectionEmptyLabel = _this$props4$selectio === void 0 ? '' : _this$props4$selectio,
          selectionTitle = _this$props4.selectionTitle,
          error = _this$props4.error,
          EmptyComponent = _this$props4.EmptyComponent,
          disabled = _this$props4.disabled,
          SplitComponent = _this$props4.SplitComponent,
          ActionComponent = _this$props4.ActionComponent,
          onDataChange = _this$props4.onDataChange,
          importButtonDisabled = _this$props4.importButtonDisabled,
          SelectedTipComponent = _this$props4.SelectedTipComponent;
      var value = this.state.value;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-userpicker user-picker'
      }, Import), _react["default"].createElement("div", {
        className: "user-picker-item spaui-userpicker-item user"
      }, _react["default"].createElement("div", {
        className: "user-picker-body spaui-userpicker-body manual-list"
      }, _react["default"].createElement(_spauiCoder["default"], {
        className: error ? 'has-error' : '',
        value: value,
        placeholder: placeholder,
        onChange: this.handleCoderChange,
        disabled: disabled
      }))), _react["default"].createElement("div", {
        className: "user-picker-split spaui-userpicker-split"
      }, _react["default"].createElement(SplitComponent, _extends({}, this.props, {
        onClick: this.handleImport,
        disabled: disabled || value.length < 1 || importButtonDisabled || false,
        label: importButtonLabel
      }))), _react["default"].createElement("div", {
        className: "user-picker-item spaui-userpicker-item selection"
      }, _react["default"].createElement("div", {
        className: "user-picker-header spaui-userpicker-header"
      }, _react["default"].createElement("div", {
        className: "titlebar"
      }, _react["default"].createElement(SelectedTipComponent, _extends({}, this.props, {
        label: selectionTitle,
        selectionTitle: selectionTitle,
        data: data
      })), _react["default"].createElement(ActionComponent, _extends({}, this.props, {
        type: "count",
        importable: false,
        canImport: false,
        data: data,
        disabled: disabled,
        onClear: this.handleClear,
        onChange: onDataChange
      })))), (0, _spauiUtils.isArray)(data) && data.length > 0 ? _react["default"].createElement("div", {
        className: "user-picker-body spaui-userpicker-body selection-list"
      }, _react["default"].createElement("ul", {
        className: "feeds spaui-userpicker-feeds"
      }, data.map(function (item, index) {
        return _react["default"].createElement(UserItemComponent, _extends({}, _this2.props, {
          ImgComponent: ImgComponent,
          InfoComponent: InfoComponent,
          key: index,
          data: item,
          onClick: function onClick(event) {
            return _this2.handleDataChange(event, item);
          },
          disabled: disabled,
          status: "delete"
        }));
      }))) : _react["default"].createElement(EmptyComponent, _extends({}, this.props, {
        label: selectionEmptyLabel,
        iconClassName: "icon-customer-guide"
      }))));
    }
  }]);

  return Import;
}(_react.PureComponent); // 组件标记


_defineProperty(Import, "propTypes", {
  data: _spauiUtils.PropTypes.array.isRequired,
  value: _spauiUtils.PropTypes.string,
  onChange: _spauiUtils.PropTypes.func,
  placeholder: _spauiUtils.PropTypes.string,
  importButtonLabel: _spauiUtils.PropTypes.string,
  onImport: _spauiUtils.PropTypes.func,
  onDataChange: _spauiUtils.PropTypes.func,
  selectionTitle: _spauiUtils.PropTypes.string,
  selectionEmptyLabel: _spauiUtils.PropTypes.string,
  error: _spauiUtils.PropTypes.bool,
  disabled: _spauiUtils.PropTypes.bool,
  importButtonDisabled: _spauiUtils.PropTypes.bool,
  SelectedTipComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  ImgComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  InfoComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  UserItemComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  EmptyComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  SplitComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  ActionComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func])
});

_defineProperty(Import, "defaultProps", {
  data: [],
  placeholder: '',
  importButtonLabel: '导入',
  selectionTitle: '已导入客户',
  selectionEmptyLabel: '请在左侧选择添加客户',
  error: false,
  disabled: false,
  SelectedTipComponent: _selected_tip_component["default"],
  ActionComponent: _action_component["default"],
  EmptyComponent: _empty_component["default"],
  SplitComponent: _split_component["default"],
  ImgComponent: _img_component["default"],
  InfoComponent: _info_component["default"],
  UserItemComponent: _user_item_component["default"]
});

(0, _spauiUtils.setComponentMark)(Import, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Import;
exports["default"] = _default;